import type { GetCourseReviewStats200RatingDistribution } from './getCourseReviewStats200RatingDistribution';
import type { GetCourseReviewStats200TagsItem } from './getCourseReviewStats200TagsItem';

/**
 * 리뷰 통계 응답
 */
export type GetCourseReviewStats200 = {
  /** 평균 평점 */
  averageRating: number;
  /** 평점별 분포 */
  ratingDistribution: GetCourseReviewStats200RatingDistribution;
  /** 인기 태그 */
  tags?: GetCourseReviewStats200TagsItem[];
  /** 총 리뷰 수 */
  totalReviews: number;
};
